export default "__VITE_ASSET__lkiOcN2M__"